import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { scanSheetState } from 'components/showtime/state/scan-sheet';
import { useSnapshot } from 'hooks/use-safe-snapshot';

const ScanNotesSheet = dynamic(
    () => import('components/showtime/components/ScanNotesSheet').then((module) => module.ScanNotesSheet),
    { ssr: false },
);

// Mounted once in the app, so the sheet works wherever a save button is, including teasers in lists
const ScanNotesSheetHost = () => {
    const router = useRouter();
    const { open, openCount } = useSnapshot(scanSheetState);

    // A sheet belongs to the page it was opened on. Query changes, like dropping the scan flag, keep it open.
    useEffect(() => {
        const withoutQuery = (url: string) => url.split(/[?#]/)[0];

        const closeOnLeave = (url: string) => {
            if (withoutQuery(url) !== withoutQuery(router.asPath)) {
                scanSheetState.open = null;
            }
        };

        router.events.on('routeChangeStart', closeOnLeave);

        return () => router.events.off('routeChangeStart', closeOnLeave);
    }, [router]);

    if (!open) {
        return null;
    }

    return (
        <ScanNotesSheet
            key={openCount}
            company={open.company}
            scan={open.scan}
            retry={open.retry}
            test={open.test}
            startCollapsed={open.startCollapsed}
            closeWhenDone={open.closeWhenDone}
        />
    );
};

export { ScanNotesSheetHost };
